import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, switchMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { addToast } from 'containers/Toasts/actions'

import {
  getReportingReasons,
  getReportingReasonsError,
  getReportingReasonsSuccess,
  restoreDefaultReasonsError,
  restoreDefaultReasonsSuccess,
  updateReportingReasonsError,
  updateReportingReasonsSuccess,
} from './actions'
import {
  GET_REPORTING_REASONS_ASYNC,
  RESTORE_DEFAULT_REASONS_ASYNC,
  UPDATE_REPORTING_REASONS_ASYNC,
} from './constants'

const getReportingReasonsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS, GET_REPORTING_REASONS_ASYNC.INITIATE),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.customizationO365)
      return true
    }),
    switchMap((action) =>
      api.settings
        .getReportingReasons(
          state$.value.partnerOptions.selectedCompany?.value,
          action.payload?.locale || ''
        )
        .pipe(
          map((response) => getReportingReasonsSuccess(response)),
          catchError((error) => of(epicsErrorHandler(getReportingReasonsError, error))),
          takeUntil(action$.pipe(ofType(GET_REPORTING_REASONS_ASYNC.CANCEL)))
        )
    )
  )

const updateReportingReasonsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(UPDATE_REPORTING_REASONS_ASYNC.INITIATE),
    mergeMap((action) =>
      api.settings
        .updateReportingReasons(
          state$.value.partnerOptions.selectedCompany?.value,
          action.payload.data,
          action.payload?.locale || ''
        )
        .pipe(
          mergeMap(() =>
            of(
              updateReportingReasonsSuccess(),
              addToast({ message: 'Reasons were successfully updated' }),
              getReportingReasons(action.payload?.locale || '')
            )
          ),
          catchError((error) =>
            of(
              epicsErrorHandler(updateReportingReasonsError, error),
              addToast({ message: error.response?.message, type: 'error' })
            )
          ),
          takeUntil(action$.pipe(ofType(UPDATE_REPORTING_REASONS_ASYNC.CANCEL)))
        )
    )
  )

const restoreDefaultReasonsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(RESTORE_DEFAULT_REASONS_ASYNC.INITIATE),
    mergeMap((action) =>
      api.settings
        .restoreDefaultReasons(
          state$.value.partnerOptions.selectedCompany?.value,
          action.payload?.locale || ''
        )
        .pipe(
          mergeMap(() =>
            of(
              restoreDefaultReasonsSuccess(),
              addToast({ message: 'Reasons were successfully restored to default' }),
              getReportingReasons(action.payload?.locale || '')
            )
          ),
          catchError((error) =>
            of(
              epicsErrorHandler(restoreDefaultReasonsError, error),
              addToast({ message: error.response?.message, type: 'error' })
            )
          ),
          takeUntil(action$.pipe(ofType(RESTORE_DEFAULT_REASONS_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(
  getReportingReasonsEpic,
  updateReportingReasonsEpic,
  restoreDefaultReasonsEpic
)
